import { useAuth } from '@/context/AuthContext'
import { usePartner } from '@/context/PartnerContext'
import { useSaveVehicleAdditionalInfo } from '@/hooks/useWizard'
import { Alert, AlertDescription, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Stack, useDisclosure, useToast } from '@chakra-ui/react'
import { useState } from 'react'
import { useInsuranceParams } from '../../context/InsuranceParamsProvider'
import type { AddVehicleInfoFormValues } from '../AddVehicleInfoForm'
import { AddVehicleInfoForm } from '../AddVehicleInfoForm'
import { WizzardHeaderButton } from './WizzardHeaderButton'

function AddVehicleInfo() {
  const { isOpen, onClose, onOpen } = useDisclosure()
  const toast = useToast()
  const { insuranceParamsId, refetchInsuranceParams } = useInsuranceParams()
  const { mutateAsync: saveVehicleAdditionalInfo } = useSaveVehicleAdditionalInfo()
  const { user } = useAuth()
  const { currentPartner } = usePartner()
  const [error, setError] = useState<string | null>(null)

  const handleFormSubmit = (values: AddVehicleInfoFormValues) =>
    saveVehicleAdditionalInfo({
      licencePlate: values.registration ?? undefined,
      paramsId: +insuranceParamsId!,
      technicalCertificateNumber: values.tpNumber ?? undefined,
      registrationCertificateNumber: values.orvNumber ?? undefined
    })
      .then(({ data }) => {
        toast({
          title: 'Informace byly odeslány do systému pojišťovny.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        })
        refetchInsuranceParams() // refreshneme udaje o aute v contextu
        onClose()
      })
      .catch((data) => {
        if (data.response.status === 400) {
          setError(Object.values(data.response.data).join(', '))
          return
        }

        toast({
          title: data.response.data.text ?? 'Chyba při odesílání informací do pojišťovny',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
      })

  return (
    <>
      <WizzardHeaderButton onClick={onOpen} isDisabled={currentPartner?.partner === 'Jap' && !user?.autorizacePpz?.hasAuthorization}>
        Doplnit RZ/TP
      </WizzardHeaderButton>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />

          <ModalHeader>Doplnit údaje o vozidle</ModalHeader>

          <ModalBody as={Stack} gap={8} pb={6}>
            <AddVehicleInfoForm onSubmit={handleFormSubmit} />
            {error && <Alert status='error'>
              <AlertDescription>{error}</AlertDescription>
            </Alert>}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default AddVehicleInfo